/**
 * Remove any extra "/" in the front, we should only keep one if there is any
 */
export const normalizeRestoreRoute = (routePath: string): string => {
  return routePath.replace(/^\/+/, "/");
};
